import { render, staticRenderFns } from "./ItemKitDinamicoForm.vue?vue&type=template&id=effd8646"
import script from "./ItemKitDinamicoForm.vue?vue&type=script&lang=ts"
export * from "./ItemKitDinamicoForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports